// extracted by mini-css-extract-plugin
export default {"GeneralLayout":"generalLayout_GeneralLayout__guIg9","Page":"generalLayout_Page__o-zJ5","Content":"generalLayout_Content__kO3SI"};